"use strict";
const { v4: uuid } = require('uuid');
const { STEP_TYPES: { TASK }, ACTION_TYPES: { SEND_EMAIL, SEND_SMS, SEND_WEBFORM }, } = require('./constants');
exports.generateSendSmsTaskStep = ({ id = uuid(), variables, data, next }) => ({
    id,
    version: '1.0.3',
    variables,
    type: TASK,
    action: SEND_SMS,
    data,
    next,
});
exports.generateSendEmailTaskStep = ({ id = uuid(), variables, data, next, }) => ({
    id,
    version: '1.0.3',
    variables,
    type: TASK,
    action: SEND_EMAIL,
    data,
    next,
});
exports.generateSendWebformTaskStep = ({ id = uuid(), variables, data, next, }) => ({
    id,
    version: '1.0.0',
    variables,
    type: TASK,
    action: SEND_WEBFORM,
    data,
    next,
});
//# sourceMappingURL=stepFactory.js.map